/**
 * JSDoc imports.
 *
 * @import { Constant } from '@app/const/constant';
 */

export enum VariableReferenceScope {
  /**
   * @see DesignVariable with props.config.scope set to @see VariableScope.session.
   *
   * @note Replaces the old @see Constant.k.SCOPE_APPLICATION constant.
   */
  application = 'app',
  /**
   * @see DesignVariable with props.config.scope set to @see VariableScope.conversation.
   *
   * @note Replaces the old @see Constant.k.SCOPE_CONVERSATION constant.
   */
  conversation = 'conv',
  /**
   * @see DesignModuleLocalVariable.
   *
   * @note Replaces the old @see Constant.k.SCOPE_MODULE constant.
   */
  module = 'mod'
}
